// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__8VbYt","icon":"SortAdornment_icon__3oEzY","up":"SortAdornment_up__AQYmQ","down":"SortAdornment_down__1lk_X","active":"SortAdornment_active__1Iduu"};